import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import HouseImg1 from '../../assets/img/house-img1.jpg'
import HouseImg2 from '../../assets/img/house-img2.jpg'
import HouseImg3 from '../../assets/img/house-img3.jpg'
import HouseImg4 from '../../assets/img/house-img4.jpg'
import HouseImg5 from '../../assets/img/house-img5.jpg'
import DownloadIcon from '../../assets/img/svg/download-white-icon.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSchedulePropertyDataById } from '../../redux/slices/propertySlice'
import { SpinnerContext } from '../../context/spinnerContext'
import { createChatRoom } from '../../redux/slices/chatSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import { appendImageURL, formatAmount } from '../../helper/function'
import CleaningPlacePhoto from './cleanPlacePhoto'
import TasksConsumableList from './tasksConsumableList'
import ReviewForm from './reviewForm'
import MoreDetails from './moreDetails'
import axios from 'axios'
import { getAuthToken } from '../../helper/storage'
import { Rating } from 'react-simple-star-rating'
import { Avatar } from 'antd'
import { PreviewImg } from '../../helper/imagepath'
import { Alert } from 'reactstrap'
import { FREEZE_CLIENT_MSG } from '../../util/constant'

const CleaningDetails = () => {
  const { schedule_id } = useParams()
  const scrollRef = useRef()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useSelector(({ auth }) => auth)
  const { changeLoader } = useContext(SpinnerContext)
  const { scheduledProperties } = useSelector(({ property }) => property)
  const [isRefresh, setIsRefresh] = useState(true)
  const [displayImages, setDisplayImages] = useState([])
  const cleaningPlacePhotos = scheduledProperties?.cleaningData?.images
  const [isScroll, setIsScroll] = useState(false)
  const was_good_guest = useMemo(() => scheduledProperties?.cleaningData?.was_good_guest || false, [scheduledProperties?.cleaningData])
  const was_house_good = useMemo(() => scheduledProperties?.cleaningData?.was_house_good || false, [scheduledProperties?.cleaningData])
  const was_smelling = useMemo(() => scheduledProperties?.cleaningData?.was_smelling || false, [scheduledProperties?.cleaningData])

  const booking_status = useMemo(
    () => scheduledProperties?.cleaningData?.property_schedule?.booking_status || false,
    [scheduledProperties?.cleaningData]
  )

  // Handle Scroll to Ref
  const handleScrollRef = useCallback(() => {
    const divElement = document.getElementById('scheduleScrollId')
    divElement?.scrollIntoView({ behavior: 'smooth' })
    setIsScroll(false)
  }, [document])

  useEffect(() => {
    if (isScroll && scrollRef.current) {
      handleScrollRef()
    }
  }, [isScroll, scheduledProperties])

  // -----Images-----------

  useEffect(() => {
    // Parse each cleaningPlacePhoto if it's a valid JSON string
    const cleaningImages = cleaningPlacePhotos?.length
      ? cleaningPlacePhotos.slice(0, 5).map((photo) => {
          try {
            return JSON.parse(photo) // Parse each image
          } catch (error) {
            return photo // If parsing fails, return the original image
          }
        })
      : cleaningPlacePhotos?.slice(0, 5) || []

    // Array of random images for fallback
    const randomImages = [HouseImg1, HouseImg2, HouseImg3, HouseImg4, HouseImg5] // Replace these with your actual random images

    // Function to get random images without repetition
    const getRandomImages = (count) => {
      const selectedImages = new Set()
      const availableImages = randomImages.filter((img) => !cleaningImages.includes(img))

      while (selectedImages.size < count && availableImages.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableImages.length)
        selectedImages.add(availableImages[randomIndex])
        availableImages.splice(randomIndex, 1) // Remove the selected image to avoid repetition
      }

      return Array.from(selectedImages)
    }

    const requiredRandomImagesCount = 5 - cleaningImages.length
    const randomImagesToDisplay = requiredRandomImagesCount > 0 ? getRandomImages(requiredRandomImagesCount) : []

    setDisplayImages([...cleaningImages, ...randomImagesToDisplay].slice(0, 5))
  }, [cleaningPlacePhotos])

  // -------------------------------

  useEffect(() => {
    if (!isRefresh) return
    if (schedule_id) {
      changeLoader(true)
      dispatch(getSchedulePropertyDataById(schedule_id))
        .then(() => {
          changeLoader(false)
          setIsRefresh(false)
          setIsScroll(true)
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }, [isRefresh])
  const onViewChat = (id) => {
    if (user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    dispatch(createChatRoom(id))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          if (payload?.data?.data) {
            const chat_room_id = payload?.data?.data?.chat_room_id
            navigate(`/chat/${chat_room_id}`, { state: id })
          } else {
            errorToast(payload?.data?.status_message || 'Something went wrong')
          }
        }
      })
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }
  const handleShareCleanning = async (id, module) => {
    changeLoader(true)
    try {
      // eslint-disable-next-line no-undef
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/cleaning/share-cleaning/${id}?module=${module}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getAuthToken()}` // passing the token in the header
        }
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `cleaning_files_${id}.zip`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      successToast(response?.data?.status_message || 'File downloaded successfully.')
      changeLoader(false)
    } catch (error) {
      console.error('Error downloading the file', error)
      changeLoader(false)
      errorToast('Cleaning images not found.' || 'Something went wrong')
    }
  }

  return (
    <>
      <div className="page-wrapper">
        {scheduledProperties?.cleaningData && booking_status !== 'completed' ? (
          scheduledProperties?.cleaningData?.property_schedule?.cancellation_charge !== null ? (
            <div className="form-header">
              <Alert color="warning popup-error-note">
                {scheduledProperties?.cleaningData?.property_schedule?.cancellation_charge
                  ? 'The cancellation charge request has been approved'
                  : 'The cancellation charge request has been declined'}
              </Alert>
            </div>
          ) : (
            <div className="form-header">
              <Alert color="warning popup-error-note">{`Wait till the admin approve the cancellation charge`}</Alert>
            </div>
          )
        ) : (
          <></>
        )}

        <div className="heading_header_div">
          <div>
            <h4>{scheduledProperties?.cleaningData?.property_schedule?.properties?.property_name}</h4>
            <p className="fs-14 black_color fw-400">
              {scheduledProperties?.cleaningData?.property_schedule &&
                `${scheduledProperties?.cleaningData?.property_schedule?.properties?.address} - ${scheduledProperties?.cleaningData?.property_schedule?.properties?.city}`}
            </p>
          </div>
          <button
            className="property_btn view_chat btn btn-primary"
            onClick={() => onViewChat(scheduledProperties?.cleaningData?.property_schedule?.property_schedule_id)}
          >
            <span className="me-2"> View Chat </span>

            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.875 3.75H4.375C4.03 3.75 3.75 4.03 3.75 4.375C3.75 4.72 4.03 5 4.375 5H11.875C12.22 5 12.5 4.72 12.5 4.375C12.5 4.03 12.22 3.75 11.875 3.75ZM9.375 6.25H4.375C4.03 6.25 3.75 6.53 3.75 6.875C3.75 7.22 4.03 7.5 4.375 7.5H9.375C9.72 7.5 10 7.22 10 6.875C10 6.53 9.72 6.25 9.375 6.25Z"
                fill="white"
              />
              <path
                d="M13.75 0H2.5C1.12125 0 0 1.12125 0 2.5V15C0 15.2425 0.14 15.4637 0.36 15.5662C0.443057 15.6047 0.533461 15.6248 0.625 15.625C0.76875 15.625 0.91125 15.575 1.025 15.48L4.60125 12.5H13.75C15.1287 12.5 16.25 11.3787 16.25 10V2.5C16.25 1.12125 15.1287 0 13.75 0ZM15 10C15 10.6888 14.44 11.25 13.75 11.25H4.375C4.22875 11.25 4.0875 11.3013 3.975 11.395L1.25 13.6662V2.5C1.25 1.81125 1.81 1.25 2.5 1.25H13.75C14.44 1.25 15 1.81125 15 2.5V10Z"
                fill="white"
              />
              <path
                d="M17.5 5C17.155 5 16.875 5.28 16.875 5.625C16.875 5.97 17.155 6.25 17.5 6.25C18.19 6.25 18.75 6.81125 18.75 7.5V18.0737L16.64 16.3863C16.529 16.2983 16.3916 16.2503 16.25 16.25H7.5C6.81 16.25 6.25 15.6888 6.25 15V14.375C6.25 14.03 5.97 13.75 5.625 13.75C5.28 13.75 5 14.03 5 14.375V15C5 16.3787 6.12125 17.5 7.5 17.5H16.03L18.9838 19.8637C19.0951 19.9519 19.233 19.9999 19.375 20C19.4663 20 19.5588 19.98 19.6462 19.9388C19.7522 19.8875 19.8415 19.8074 19.9041 19.7077C19.9667 19.608 19.9999 19.4927 20 19.375V7.5C20 6.12125 18.8787 5 17.5 5Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div>
          <h4 className="house_img_gal_title">Clean Place Photos</h4>
          <div className="house_img_gal_main_div mb-4">
            <div className="row">
              <div className="col-md-6">
                <div className="main_big_img">
                  <img
                    className="img-fluid w-100"
                    src={displayImages?.[0]?.s3Url ? appendImageURL(displayImages?.[0]?.s3Url) : HouseImg1}
                    alt="Image"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="house_img_mb main_small_img">
                  <img
                    className="img-fluid w-100"
                    src={displayImages?.[1]?.s3Url ? appendImageURL(displayImages?.[1]?.s3Url) : HouseImg1}
                    alt="Image"
                  />
                </div>
                <div className="main_small_img">
                  <img
                    className="img-fluid w-100"
                    src={displayImages?.[2]?.s3Url ? appendImageURL(displayImages?.[2]?.s3Url) : HouseImg1}
                    alt="Image"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="house_img_mb main_small_img">
                  <img
                    className="img-fluid w-100"
                    src={displayImages?.[3]?.s3Url ? appendImageURL(displayImages?.[3]?.s3Url) : HouseImg1}
                    alt="Image"
                  />
                </div>
                <div className="main_small_img last_img_rad">
                  <img
                    className="img-fluid w-100"
                    src={displayImages?.[4]?.s3Url ? appendImageURL(displayImages?.[4]?.s3Url) : HouseImg1}
                    alt="Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* cleaning reports Start */}
        {booking_status === 'completed' && (
          <div className="mb-4">
            <h4 className="house_img_gal_title">Cleaning Reports</h4>
            <div className="cleaning_report_main_div">
              {scheduledProperties?.cleaningData?.was_smelling !== null ? (
                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <>
                        <h4 className="cleaning_report_title">Cleaner Reviews</h4>

                        <div className="d-flex align-items-center gap-2 mb-3">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M13.0647 3.87097H13.6377C13.838 4.43286 14.3703 4.83871 15.0002 4.83871C15.6301 4.83871 16.1624 4.43286 16.3627 3.87097H16.9357C17.7359 3.87097 18.3873 3.21956 18.3873 2.41935C18.3873 1.61915 17.7359 0.967742 16.9357 0.967742H16.3627C16.1624 0.405847 15.6301 0 15.0002 0C14.3703 0 13.838 0.405847 13.6377 0.967742H13.0647C12.2645 0.967742 11.6131 1.61915 11.6131 2.41935C11.6131 3.21956 12.2645 3.87097 13.0647 3.87097ZM15.0002 3.87097C14.7332 3.87097 14.5163 3.65359 14.5163 3.3871V2.90323H15.4841V3.3871C15.4841 3.65359 15.2672 3.87097 15.0002 3.87097ZM17.4195 2.41935C17.4195 2.68585 17.2026 2.90323 16.9357 2.90323H16.4518V1.93548H16.9357C17.2026 1.93548 17.4195 2.15286 17.4195 2.41935ZM15.0002 0.967742C15.2672 0.967742 15.4841 1.18512 15.4841 1.45161V1.93548H14.5163V1.45161C14.5163 1.18512 14.7332 0.967742 15.0002 0.967742ZM13.0647 1.93548H13.5486V2.90323H13.0647C12.7977 2.90323 12.5808 2.68585 12.5808 2.41935C12.5808 2.15286 12.7977 1.93548 13.0647 1.93548ZM28.5486 5.32258H27.9756C27.7753 4.76069 27.243 4.35484 26.6131 4.35484C25.9832 4.35484 25.4509 4.76069 25.2506 5.32258H24.6776C23.8774 5.32258 23.226 5.97399 23.226 6.77419C23.226 7.57439 23.8774 8.22581 24.6776 8.22581H25.2506C25.3207 8.42321 25.4327 8.60309 25.579 8.75309C25.7252 8.90309 25.9022 9.01966 26.0978 9.09478C26.0023 9.69236 25.6735 9.92812 25.2094 10.2508C24.5417 10.7158 23.7099 11.294 23.7099 13.0645H24.6776C24.6776 11.7998 25.156 11.4669 25.7621 11.0454C26.2951 10.6742 26.9405 10.2171 27.0693 9.11274C27.2776 9.04317 27.4674 8.92718 27.6243 8.77354C27.7813 8.61989 27.9012 8.4326 27.9752 8.22581H28.5486C29.3488 8.22581 30.0002 7.57439 30.0002 6.77419C30.0002 5.97399 29.3488 5.32258 28.5486 5.32258ZM26.6131 5.32258C26.8801 5.32258 27.097 5.53996 27.097 5.80645V6.29032H26.1292V5.80645C26.1292 5.53996 26.3461 5.32258 26.6131 5.32258ZM24.1937 6.77419C24.1937 6.5077 24.4106 6.29032 24.6776 6.29032H25.1615V7.25806H24.6776C24.4106 7.25806 24.1937 7.04069 24.1937 6.77419ZM26.6131 8.22581C26.3461 8.22581 26.1292 8.00843 26.1292 7.74194V7.25806H27.097V7.74194C27.097 8.00843 26.8801 8.22581 26.6131 8.22581ZM28.5486 7.25806H28.0647V6.29032H28.5486C28.8155 6.29032 29.0324 6.5077 29.0324 6.77419C29.0324 7.04069 28.8155 7.25806 28.5486 7.25806ZM23.2052 13.6311C23.0034 11.6845 21.3538 10.1613 19.355 10.1613C19.1067 10.1613 18.859 10.1854 18.6153 10.2333C18.051 8.74512 16.6269 7.74194 15.0002 7.74194C13.5472 7.74194 12.2508 8.53458 11.5845 9.79506C11.2775 9.71714 10.9621 9.67762 10.6453 9.67742C8.51087 9.67742 6.77438 11.4139 6.77438 13.5484C6.77438 13.5774 6.77983 13.6065 6.78073 13.6355C6.21563 13.8343 5.80664 14.3675 5.80664 15C5.80664 15.6497 6.23831 16.1948 6.82803 16.379L8.47761 27.9227C8.64654 29.1067 9.67622 30 10.8724 30H19.128C20.3242 30 21.3538 29.1067 21.5228 27.9227L23.1723 16.3791C23.7621 16.1948 24.1937 15.6497 24.1937 15C24.1937 14.3623 23.7777 13.8258 23.2052 13.6311ZM10.6453 10.6452C10.9939 10.6452 11.3402 10.7095 11.6745 10.8368L12.1236 11.0076L12.2973 10.5606C12.7352 9.43597 13.7965 8.70968 15.0002 8.70968C16.3447 8.70968 17.5041 9.62377 17.8193 10.932L17.9426 11.4435L18.4418 11.2781C18.74 11.1794 19.0472 11.129 19.355 11.129C20.7906 11.129 21.9831 12.1776 22.2148 13.5484H7.74212C7.74212 11.9472 9.04416 10.6452 10.6453 10.6452ZM19.128 29.0323H10.8724C10.2524 29.0323 9.70858 28.6316 9.50632 28.0645H20.4941C20.2918 28.6316 19.7484 29.0323 19.128 29.0323ZM20.663 27.0968H9.33739L7.81652 16.4516H22.1843L20.663 27.0968ZM22.7421 15.4839H7.25825C6.99128 15.4839 6.77438 15.2665 6.77438 15C6.77438 14.7335 6.99128 14.5161 7.25825 14.5161H22.7421C23.0091 14.5161 23.226 14.7335 23.226 15C23.226 15.2665 23.0091 15.4839 22.7421 15.4839Z"
                              fill="#1C3A77"
                            />
                            <path
                              d="M11.129 17.4194C10.3288 17.4194 9.67742 18.0708 9.67742 18.871V24.6775C9.67742 25.4777 10.3288 26.1291 11.129 26.1291C11.9292 26.1291 12.5806 25.4777 12.5806 24.6775V18.871C12.5806 18.0708 11.9292 17.4194 11.129 17.4194ZM11.6129 24.6775C11.6129 24.9444 11.396 25.1613 11.129 25.1613C10.8621 25.1613 10.6452 24.9444 10.6452 24.6775V18.871C10.6452 18.604 10.8621 18.3871 11.129 18.3871C11.396 18.3871 11.6129 18.604 11.6129 18.871V24.6775ZM15 17.4194C14.1998 17.4194 13.5484 18.0708 13.5484 18.871V24.6775C13.5484 25.4777 14.1998 26.1291 15 26.1291C15.8002 26.1291 16.4516 25.4777 16.4516 24.6775V18.871C16.4516 18.0708 15.8002 17.4194 15 17.4194ZM15.4839 24.6775C15.4839 24.9444 15.267 25.1613 15 25.1613C14.733 25.1613 14.5161 24.9444 14.5161 24.6775V18.871C14.5161 18.604 14.733 18.3871 15 18.3871C15.267 18.3871 15.4839 18.604 15.4839 18.871V24.6775ZM18.871 17.4194C18.0708 17.4194 17.4194 18.0708 17.4194 18.871V24.6775C17.4194 25.4777 18.0708 26.1291 18.871 26.1291C19.6712 26.1291 20.3226 25.4777 20.3226 24.6775V18.871C20.3226 18.0708 19.6712 17.4194 18.871 17.4194ZM19.3548 24.6775C19.3548 24.9444 19.1379 25.1613 18.871 25.1613C18.604 25.1613 18.3871 24.9444 18.3871 24.6775V18.871C18.3871 18.604 18.604 18.3871 18.871 18.3871C19.1379 18.3871 19.3548 18.604 19.3548 18.871V24.6775ZM9.67742 11.613H10.6452V12.5807H9.67742V11.613ZM14.0323 9.67747H15V10.6452H14.0323V9.67747ZM15.4839 11.613H16.4516V12.5807H15.4839V11.613ZM12.5806 11.613H13.5484V12.5807H12.5806V11.613ZM20.9099 5.64489C21.5419 4.44682 22.2581 3.08896 22.2581 1.45166H21.2903C21.2903 2.84962 20.6619 4.04091 20.054 5.19289C19.4725 6.29509 18.871 7.43533 18.871 8.70972H19.8387C19.8387 7.67466 20.359 6.68872 20.9099 5.64489ZM9.19355 8.70972H10.1613C10.1613 6.81392 9.57913 5.87031 9.06526 5.03866C8.61532 4.30831 8.22581 3.67801 8.22581 2.4194H7.25806C7.25806 3.95231 7.75845 4.76267 8.2419 5.5466C8.73139 6.33973 9.19355 7.08821 9.19355 8.70972ZM5.0022 9.08872C4.46026 8.60315 3.9877 8.1736 3.89129 7.16218C4.08929 7.08822 4.2687 6.9718 4.41691 6.82111C4.56512 6.67041 4.67853 6.48909 4.74919 6.28989H5.32258C6.12278 6.28989 6.77419 5.63847 6.77419 4.83827C6.77419 4.03807 6.12278 3.38666 5.32258 3.38666H4.74962C4.54929 2.82531 4.01698 2.4194 3.3871 2.4194C2.75722 2.4194 2.2249 2.82525 2.02458 3.38714H1.45161C0.651411 3.38714 0 4.03856 0 4.83876C0 5.63896 0.651411 6.29037 1.45161 6.29037H2.02458C2.09828 6.49661 2.21775 6.68348 2.37403 6.83693C2.5303 6.99038 2.71932 7.10642 2.92687 7.17634C3.04361 8.61737 3.76252 9.27773 4.35671 9.80956C4.91764 10.3118 5.32258 10.6747 5.32258 11.613H6.29032C6.29032 10.2421 5.60607 9.62908 5.0022 9.08872ZM2.90323 5.32263H3.87097V5.8065C3.87097 6.07299 3.65407 6.29037 3.3871 6.29037C3.12012 6.29037 2.90323 6.07299 2.90323 5.8065V5.32263ZM5.80645 4.83876C5.80645 5.10525 5.58956 5.32263 5.32258 5.32263H4.83871V4.35489H5.32258C5.58956 4.35489 5.80645 4.57227 5.80645 4.83876ZM3.3871 3.38714C3.65407 3.38714 3.87097 3.60452 3.87097 3.87102V4.35489H2.90323V3.87102C2.90323 3.60452 3.12012 3.38714 3.3871 3.38714ZM0.967742 4.83876C0.967742 4.57227 1.18464 4.35489 1.45161 4.35489H1.93548V5.32263H1.45161C1.18464 5.32263 0.967742 5.10525 0.967742 4.83876Z"
                              fill="#1C3A77"
                            />
                          </svg>

                          <div>
                            <p className={`fs-16 fw-400 ${!was_smelling ? 'green_color' : 'red_color'}`}>House Smelling Weird</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M25.6624 16.1596V10.8311L26.0819 11.0561C26.5676 11.3174 27.1266 11.3742 27.6557 11.2148C28.1842 11.0561 28.6196 10.7004 28.8815 10.2146C29.4217 9.21152 29.0444 7.95527 28.0395 7.41387L15.603 0.740625C14.9819 0.406055 14.2413 0.410742 13.6266 0.75L9.1313 3.1623V1.11973C9.13072 0.502148 8.62974 0 8.01334 0H5.9022C5.2858 0 4.78423 0.502148 4.78423 1.11973V5.49492L1.20709 7.41387C0.202789 7.95469 -0.174555 9.21094 0.365679 10.2146C0.627593 10.701 1.06294 11.0561 1.59146 11.2148C1.78834 11.274 1.9899 11.3033 2.1897 11.3033C2.52662 11.3033 2.8606 11.2201 3.16529 11.0561L3.58482 10.8311V23.0092C3.58482 23.7721 4.20533 24.3926 4.96822 24.3926H15.5626C16.3102 27.6018 19.1936 30 22.6272 30C26.6268 30 29.8805 26.7463 29.8805 22.7467C29.8811 19.8299 28.1502 17.3104 25.6624 16.1596ZM5.72115 1.11973C5.72115 1.0207 5.80377 0.936914 5.9022 0.936914H8.01334C8.11119 0.936914 8.19439 1.0207 8.19439 1.11973V3.66504L5.72115 4.99219V1.11973ZM2.72173 10.2311C2.4563 10.374 2.15044 10.4045 1.86158 10.3178C1.57212 10.2305 1.33365 10.0359 1.19068 9.76992C1.11994 9.63945 1.07585 9.49622 1.06096 9.34855C1.04607 9.20088 1.06069 9.05173 1.10396 8.90977C1.19127 8.62031 1.38521 8.38184 1.65064 8.23887L5.46685 6.19102L5.48267 6.18223L14.0743 1.57266C14.4141 1.38516 14.819 1.38223 15.1594 1.56562L27.596 8.23887C27.727 8.3089 27.8429 8.40427 27.9369 8.51944C28.0308 8.63461 28.1009 8.76728 28.1432 8.90977C28.2305 9.19922 28.1995 9.50449 28.0565 9.76992C27.9135 10.0359 27.6751 10.2305 27.3856 10.3178C27.0967 10.4045 26.7909 10.374 26.5254 10.2311C26.5254 10.2311 26.5249 10.2311 26.5249 10.2305L14.8448 3.96387C14.7756 3.92695 14.6995 3.9082 14.6233 3.9082C14.5471 3.9082 14.471 3.92695 14.4018 3.96387L2.72173 10.2311ZM4.52173 23.0092V10.3283L14.6233 4.9084L24.7249 10.3283V15.8027C24.0447 15.597 23.3379 15.4925 22.6272 15.4928C21.0364 15.4928 19.5639 16.0078 18.3668 16.8797V14.6045C18.3668 14.3455 18.1571 14.1363 17.8987 14.1363H11.3467C11.0877 14.1363 10.8786 14.3461 10.8786 14.6045V23.4557H4.9688C4.72212 23.4557 4.52173 23.2553 4.52173 23.0092ZM11.8149 23.4557V15.0732H17.4305V17.6924C16.159 18.9996 15.3745 20.7832 15.3745 22.7467C15.3745 22.9857 15.3862 23.2225 15.409 23.4557H11.8149ZM22.6278 29.0631C19.5182 29.0631 16.926 26.8043 16.4063 23.8406C16.4057 23.8365 16.4051 23.8318 16.404 23.8277C16.343 23.4762 16.3108 23.1146 16.3108 22.7461C16.3108 19.2633 19.1444 16.4297 22.6272 16.4297C26.11 16.4297 28.9436 19.2633 28.9436 22.7461C28.9442 26.2295 26.1106 29.0631 22.6278 29.0631ZM27.6762 21.5285C27.5567 21.1523 27.2127 20.9016 26.8219 20.9016H26.8143L24.2713 20.9062L23.4909 18.4869V18.4863C23.369 18.1107 23.0227 17.8582 22.6284 17.8582C22.2317 17.8582 21.8854 18.1119 21.7676 18.4863L20.9854 20.9057L18.4471 20.901H18.4389C18.0475 20.901 17.703 21.1506 17.5805 21.5256C17.4586 21.9012 17.5917 22.3084 17.911 22.5393L19.9706 24.0311L19.1801 26.4469C19.0583 26.823 19.1901 27.2303 19.5065 27.4588C19.667 27.5766 19.8551 27.6357 20.0426 27.6357C20.2301 27.6357 20.4165 27.5771 20.5747 27.46L22.629 25.9617L24.6821 27.4588C25.002 27.6938 25.4315 27.6938 25.7485 27.4605C26.0696 27.2279 26.2014 26.8189 26.0766 26.4457L25.2868 24.0311L27.3446 22.541C27.5003 22.4294 27.6164 22.2711 27.6761 22.089C27.7357 21.907 27.7358 21.7106 27.6762 21.5285ZM24.7184 23.2857C24.3991 23.5166 24.2661 23.9244 24.3885 24.3012L25.1561 26.6467L23.1628 25.193C23.0028 25.0758 22.8153 25.0166 22.6278 25.0166C22.4409 25.0166 22.254 25.0752 22.0946 25.1918L20.1001 26.6461L20.8676 24.2994C20.9895 23.9238 20.8565 23.5166 20.5372 23.2857L18.5385 21.8385L21.0065 21.8432C21.4008 21.8432 21.7471 21.5906 21.869 21.215L22.6284 18.8666L23.386 21.215C23.4447 21.3977 23.5599 21.557 23.7151 21.6699C23.8702 21.7828 24.0572 21.8435 24.2491 21.8432L26.7165 21.8385L24.7184 23.2857Z"
                              fill="#1C3A77"
                              stroke="#1C3A77"
                              strokeWidth="0.3"
                            />
                          </svg>

                          <div>
                            <p className={`fs-16 fw-400 ${was_house_good ? 'green_color' : 'red_color'}`}>House In Good Condition</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M27.3051 30C26.016 29.9414 25.4301 28.7109 25.3129 28.0664L24.141 22.8516C23.4965 22.4414 22.0902 21.3867 20.8012 20.2734C18.0473 17.9297 18.0473 17.168 18.0473 16.9336V11.0742L17.6957 11.25L17.5785 11.9531V12.0117C17.2855 13.5352 16.8754 14.5312 16.4066 14.9414C15.9379 15.293 15.3519 15.293 14.9418 15C14.473 14.707 14.1215 14.0625 14.3559 13.0664L15.3519 9.43359C15.3519 9.375 15.4105 9.31641 15.4691 9.25781L19.3949 6.5625C20.2152 6.09375 21.2699 6.09375 22.1488 6.5625C22.8519 6.97266 23.3207 7.61719 23.3207 8.26172V16.9336L27.7738 20.9766C27.8324 21.0352 27.8324 21.0938 27.8324 21.1523L29.1801 28.0664V28.125C29.1801 28.6523 29.0043 29.1211 28.7113 29.4727C28.184 29.9414 27.4809 30 27.3051 30ZM18.7504 10.6641V16.9336C18.7504 17.0508 18.8676 17.6953 21.2699 19.7461C22.559 20.918 24.0824 22.0312 24.6098 22.3242C24.6684 22.3242 24.7269 22.4414 24.7855 22.5L26.016 27.8906C26.016 27.9492 26.309 29.2383 27.3051 29.2969C27.3051 29.2969 27.891 29.2969 28.184 28.9453C28.4184 28.7695 28.4769 28.4766 28.4769 28.125L27.1879 21.3867L22.7348 17.3438C22.6176 17.2852 22.6176 17.168 22.6176 17.1094V8.26172C22.6176 7.85156 22.3246 7.44141 21.7973 7.20703C21.3285 6.91406 20.5082 6.73828 19.8051 7.14844L15.9965 9.78516L15.059 13.3008C14.8832 13.8867 15.059 14.2383 15.2934 14.4141C15.5277 14.5312 15.7621 14.5312 15.9379 14.3555C16.0551 14.2969 16.5238 13.8281 16.8754 11.8945L16.9926 11.0156C17.0512 10.8984 17.1098 10.7812 17.1684 10.7227L18.223 10.1367L20.5082 8.78906C20.684 8.73047 20.9184 8.78906 20.9769 8.96484C21.0941 9.08203 21.0355 9.31641 20.8598 9.43359L18.7504 10.6641Z"
                              fill="#1C3A77"
                              stroke="#1C3A77"
                              strokeWidth="0.2"
                            />
                            <path
                              d="M15.2937 29.8828C15.0593 29.8828 14.7664 29.8242 14.532 29.707C14.0633 29.4727 13.7117 29.1211 13.5359 28.5938C13.3601 28.125 13.3601 27.5977 13.5945 27.1875L18.1648 17.168C18.2234 16.9922 18.4578 16.875 18.6336 16.9922C18.8093 17.0508 18.8679 17.2852 18.8093 17.4609L14.239 27.4805C14.0633 27.7734 14.0633 28.0664 14.1804 28.3594C14.2976 28.6523 14.532 28.9453 14.825 29.0625C15.4109 29.3555 16.114 29.0625 16.407 28.4766L20.45 19.6289C20.5086 19.4531 20.7429 19.3945 20.9187 19.5117C21.0945 19.5703 21.1531 19.7461 21.0945 19.9219L17.0515 28.7695C16.7 29.4727 16.0554 29.8828 15.2937 29.8828ZM25.8992 13.7695H25.8406L22.9109 13.7109C22.7351 13.7109 22.6179 13.5352 22.6179 13.3008C22.6179 13.125 22.7351 13.0078 22.9695 13.0078L25.8406 13.0664C26.3679 13.125 26.8953 12.6562 26.8953 12.1289C26.9539 11.8359 26.8367 11.6016 26.6609 11.4258C26.4851 11.25 26.2508 11.1328 26.0164 11.1328L22.9109 11.0156C22.7351 11.0156 22.6179 10.8398 22.6179 10.6641C22.6179 10.4297 22.7351 10.3125 22.9695 10.3125L26.0164 10.4297C26.4851 10.4297 26.8953 10.6055 27.1883 10.957C27.4812 11.3086 27.657 11.7188 27.5984 12.1875C27.5398 13.0664 26.7781 13.7695 25.8992 13.7695ZM21.3875 5.625C19.864 5.625 18.575 4.39453 18.575 2.8125C18.575 1.28906 19.864 0 21.3875 0C22.9695 0 24.2 1.28906 24.2 2.8125C24.2 4.39453 22.9695 5.625 21.3875 5.625ZM21.3875 0.703125C20.2742 0.703125 19.2781 1.64062 19.2781 2.8125C19.2781 3.98438 20.2742 4.92188 21.3875 4.92188C22.5593 4.92188 23.4968 3.98438 23.4968 2.8125C23.4968 1.64062 22.5593 0.703125 21.3875 0.703125ZM7.79372 28.8281C7.55935 28.8281 7.32497 28.7109 7.14919 28.5938L1.23122 24.082C0.762474 23.6719 0.645286 22.9688 1.05544 22.5L7.20779 14.4727C7.38357 14.1797 7.73513 14.0039 8.08669 14.0039C8.32107 14.0039 8.55544 14.1211 8.73122 14.2383L14.6492 18.75C14.8836 18.9258 15.0593 19.2188 15.0593 19.5117C15.1179 19.8047 15.0593 20.0977 14.8836 20.332L8.73122 28.3594C8.49685 28.6523 8.14529 28.8281 7.79372 28.8281ZM8.08669 14.707C7.96951 14.707 7.85232 14.7656 7.73513 14.8828L1.58279 22.9102C1.4656 23.0859 1.52419 23.3789 1.69997 23.4961L7.55935 28.0078C7.61794 28.0664 7.73513 28.125 7.79372 28.125C7.96951 28.125 8.08669 28.0664 8.14529 27.9492L14.2976 19.9219C14.3562 19.8047 14.4148 19.6875 14.3562 19.5703C14.3562 19.5117 14.2976 19.3945 14.239 19.3359L8.32107 14.8242C8.26247 14.7656 8.14529 14.707 8.08669 14.707Z"
                              fill="#1C3A77"
                              stroke="#1C3A77"
                              strokeWidth="0.2"
                            />
                            <path
                              d="M4.39508 22.7931C4.33648 22.7931 4.2193 22.7345 4.1607 22.6759C4.04351 22.5587 3.98492 22.3829 4.10211 22.2072L7.73492 17.5197C7.85211 17.3439 8.02789 17.3439 8.20367 17.4611C8.37945 17.5783 8.37945 17.754 8.26226 17.9298L4.68805 22.6173C4.57086 22.7345 4.51226 22.7931 4.39508 22.7931ZM6.15289 24.1408C6.0943 24.1408 5.97711 24.0822 5.91851 24.0236C5.80133 23.9064 5.74273 23.7306 5.85992 23.5548L9.49273 18.8673C9.60992 18.6915 9.7857 18.6915 9.96148 18.8087C10.1373 18.9259 10.1373 19.1017 10.0201 19.2775L6.44586 23.965C6.38726 24.0822 6.27008 24.1408 6.15289 24.1408ZM7.9107 25.4884C7.85211 25.4884 7.73492 25.4298 7.67633 25.3712C7.55914 25.254 7.50055 25.0783 7.61773 24.9025L11.2505 20.215C11.3677 20.0392 11.6021 20.0392 11.7193 20.1564C11.8951 20.2736 11.8951 20.4493 11.7779 20.6251L8.20367 25.3126C8.14508 25.4298 8.02789 25.4884 7.9107 25.4884ZM1.99273 26.5431C1.75836 26.5431 1.46539 26.4259 1.28961 26.2501C0.762265 25.84 0.645077 25.0783 1.05523 24.5509C1.28961 24.2579 1.64117 24.0822 1.99273 24.0822C2.2857 24.0822 2.52008 24.1993 2.75445 24.3165C2.98883 24.5509 3.16461 24.8439 3.2232 25.1368C3.2818 25.4884 3.16461 25.7814 2.98883 26.0743C2.75445 26.3673 2.40289 26.5431 1.99273 26.5431ZM1.99273 24.7853C1.87555 24.7853 1.69976 24.8439 1.58258 25.0197C1.46539 25.1954 1.46539 25.547 1.69976 25.7228C1.81695 25.7814 1.87555 25.84 1.99273 25.84C2.16851 25.84 2.3443 25.7228 2.40289 25.6056C2.52008 25.4884 2.52008 25.3712 2.52008 25.254C2.52008 25.0783 2.46148 24.9611 2.3443 24.9025C2.22711 24.8439 2.10992 24.7853 1.99273 24.7853ZM5.74273 29.3556C5.50836 29.3556 5.21539 29.297 4.98101 29.1212C4.45367 28.7111 4.39508 27.9493 4.80523 27.422C5.03961 27.129 5.39117 26.9533 5.74273 26.9533C6.0357 26.9533 6.27008 27.0118 6.50445 27.1876C6.73883 27.3634 6.91461 27.6564 6.9732 28.0079C6.9732 28.3009 6.91461 28.6525 6.73883 28.8868C6.50445 29.1798 6.15289 29.3556 5.74273 29.3556ZM5.74273 27.6564C5.56695 27.6564 5.44976 27.715 5.33258 27.8322C5.1568 28.0665 5.21539 28.4181 5.44976 28.5939C5.50836 28.6525 5.62555 28.6525 5.74273 28.6525C5.91851 28.6525 6.0357 28.5939 6.15289 28.4767C6.27008 28.3595 6.27008 28.2423 6.27008 28.0665C6.27008 27.9493 6.15289 27.8322 6.0357 27.7736C5.97711 27.6564 5.85992 27.6564 5.74273 27.6564ZM12.7154 18.047C12.5982 18.047 12.5396 18.047 12.481 17.9884L10.0787 16.172C10.0201 16.1134 9.96148 15.9962 9.96148 15.9376C9.96148 15.8204 9.96148 15.7618 10.0201 15.6447L12.3638 12.5978C12.481 12.422 12.7154 12.422 12.8326 12.5392L15.2349 14.3556C15.4107 14.4728 15.4107 14.7072 15.2935 14.8829L12.9498 17.9298C12.8912 17.9884 12.8326 18.047 12.7154 18.047ZM10.7818 15.8204L12.5982 17.2267L14.5318 14.7072L12.7154 13.3009L10.7818 15.8204Z"
                              fill="#1C3A77"
                              stroke="#1C3A77"
                              strokeWidth="0.2"
                            />
                          </svg>

                          <div>
                            <p className={`fs-16 fw-400 ${was_good_guest ? 'green_color' : 'red_color'}`}>Good Guest</p>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
                <div className="damaged_objects_contains_div">
                  <h4 className="cleaning_report_title">Damaged Objects</h4>
                  <div className="damaged_object_img_grid">
                    {displayImages.map((img, index) => (
                      <img
                        key={index}
                        className="img-fluid w-100"
                        src={typeof img === 'string' ? img : img.imageKey}
                        alt={`Cleaning Image ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div> */}
                </div>
              ) : (
                <div>
                  <p className="fs-16 fw-400 black_color">No Cleaner Reviews.</p>
                </div>
              )}
            </div>
          </div>
        )}
        {/* cleaning reports End */}

        {/* more details Start */}
        <div className="mb-4">
          <h4 className="house_img_gal_title">More details</h4>
          <div className="more_details_main_div">
            <MoreDetails scheduledProperties={scheduledProperties?.cleaningData} finalAmount={formatAmount(scheduledProperties?.finalAmount)} />
          </div>
        </div>

        {/*  Tasks List*/}
        {booking_status === 'completed' && (
          <div className="mb-4">
            <h4 className="house_img_gal_title">Tasks</h4>
            <div className="more_details_main_div more_details_main_div_scroll">
              <div className="row">
                <TasksConsumableList
                  itemKey="tasks"
                  dataList={scheduledProperties?.cleaningData?.cleaning_checklist || []}
                  noDataMessage="No Tasks Yet."
                />
              </div>
            </div>
          </div>
        )}
        {booking_status === 'completed' && (
          <div className="mb-4">
            <h4 className="house_img_gal_title">Consumables (Low on Quantity)</h4>
            <div className="more_details_main_div more_details_main_div_scroll">
              <div className="row">
                <TasksConsumableList
                  itemKey="consumables"
                  dataList={scheduledProperties?.cleaningData?.cleaningConsumables || []}
                  noDataMessage="No Consumables Yet."
                />
              </div>
            </div>
          </div>
        )}

        {/* Extra Cleaning photos */}
        <div className="extra_cleaning_main_div mb-4">
          <div className="d-flex align-items-center gap-2" style={{ justifyContent: 'space-between' }}>
            <h4 className="house_img_gal_title">Extra Cleaning photos</h4>
            <div
              className="icon_box_div gray_icon mb-2"
              onClick={() => handleShareCleanning(scheduledProperties?.cleaningData?.cleaning_id, 'cleaning_complete')}
            >
              <img src={DownloadIcon} alt="download" />
            </div>
          </div>
          <div className="extra_cleaning_gal_div extra_cleaning_border">
            <CleaningPlacePhoto
              images={scheduledProperties?.cleaningData?.images}
              scheduledProperties={scheduledProperties?.cleaningData?.images}
              noDataMessage="No Extra Cleaning Photos."
            />
          </div>
        </div>
        {scheduledProperties?.cleaningData?.cleaning_reports?.length > 0 && (
          <div className="extra_cleaning_main_div mb-4">
            <div className="d-flex align-items-center gap-2" style={{ justifyContent: 'space-between' }}>
              <h4 className="house_img_gal_title">Cleaning Report</h4>
              <div
                className="icon_box_div gray_icon mb-2"
                onClick={() => handleShareCleanning(scheduledProperties?.cleaningData?.cleaning_id, 'cleaning_reports')}
              >
                <img src={DownloadIcon} alt="download" />
              </div>
            </div>
            <div className="extra_cleaning_border report-card">
              {scheduledProperties?.cleaningData?.cleaning_reports?.map((item, index) => {
                return (
                  <div className="extra_cleaning_border m-3 report-conetnt-part" key={`report-${index}`}>
                    <div className="report-header report-item">
                      <h5 className="report-type">{item?.cleaning_reports_category?.category}</h5>
                    </div>
                    <div className="report-content">
                      {item?.title && (
                        <div className="report-head-title report-item">
                          Issue Name: <span>{item?.title || '--'}</span>
                        </div>
                      )}
                      {item?.description && (
                        <div className="report-item describe-item">
                          Describe Issue:{' '}
                          <div>
                            <span> {item?.description || '--'}</span>
                          </div>
                        </div>
                      )}
                      {item?.images?.length > 0 && (
                        <>
                          <div className="report-item">Evidence Photos</div>
                          <div className="extra_cleaning_gal_div report-item">
                            <CleaningPlacePhoto images={item?.images} scheduledProperties={item?.images} noDataMessage="No Report Photos." />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {booking_status === 'completed' && (
          <div id="scheduleScrollId" ref={scrollRef}>
            {scheduledProperties?.cleaningData?.cleaning_reviews?.cleaning_review_id ? (
              <div className="review_sec_main_div">
                <h4 className="house_img_gal_title">Reviews</h4>
                <div className="review_iteam">
                  <div className="review_sec">
                    <div className="review_box">
                      <div className="review_sec_dataset">
                        <div className="review_user_img_sec">
                          <Avatar
                            size={40}
                            className="review_user"
                            src={
                              scheduledProperties?.cleaningData?.property_schedule?.schedule_cleaners?.cleaners?.profile_image
                                ? appendImageURL(scheduledProperties?.cleaningData?.property_schedule?.schedule_cleaners?.cleaners?.profile_image)
                                : PreviewImg
                            }
                            alt="review_user"
                          />
                        </div>
                        <div className="review_sec_data">
                          <h4 className="review_user_name">
                            {' '}
                            {scheduledProperties?.cleaningData?.property_schedule?.schedule_cleaners?.cleaners?.first_name}{' '}
                            {scheduledProperties?.cleaningData?.property_schedule?.schedule_cleaners?.cleaners?.last_name}
                          </h4>
                          <div className="review_rating">
                            {/* {Array(Math.max(0, Math.floor(Number(reviewState[index]?.star || 0))))
                          .fill(0)
                          .map((_, i) => (
                            <img className="reting_star" key={i} src={reting_star} alt="rating_star" />
                          ))} */}
                            <Rating
                              className="star_img"
                              initialValue={scheduledProperties?.cleaningData?.cleaning_reviews?.star} // Set initial value
                              size={15}
                              fillColor="#FD9B2E"
                              emptyColor="gray"
                              allowFraction
                              readonly
                            />
                          </div>
                          <div>
                            <p className="review_text">{scheduledProperties?.cleaningData?.cleaning_reviews?.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <ReviewForm scheduledProperties={scheduledProperties?.cleaningData} setIsRefresh={setIsRefresh} />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default CleaningDetails
